import CasestudyService from 'src/modules/casestudy/casestudyService';
import selectors from 'src/modules/casestudy/list/casestudyListSelectors';
import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/casestudy/list/casestudyListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'CASESTUDY_LIST';

// Only the most recent fetch may update the list. Navigating from a company page
// to the list page starts a filtered and an unfiltered fetch, and without this
// whichever response arrived last won.
let latestFetchId = 0;

const casestudyListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doChangeSelected(payload) {
    return {
      type: casestudyListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: casestudyListActions.RESETED,
    });

    dispatch(casestudyListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: casestudyListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await CasestudyService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.casestudy.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: casestudyListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: casestudyListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePaginationAndSort: (pagination, sorter) => async (
    dispatch,
    getState,
  ) => {
    dispatch({
      type: casestudyListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch({
      type: casestudyListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(casestudyListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (
    dispatch,
    getState,
  ) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(casestudyListActions.doFetch(filter, rawFilter, true));
  },

  doFetch: (filter?, rawFilter?, keepPagination = false) => async (
    dispatch,
    getState,
  ) => {
    const fetchId = ++latestFetchId;

    try {
      dispatch({
        type: casestudyListActions.FETCH_STARTED,
        payload: { filter, rawFilter, keepPagination },
      });

      const response = await CasestudyService.list(
        filter,
        selectors.selectOrderBy(getState()),
        selectors.selectLimit(getState()),
        selectors.selectOffset(getState()),
      );

      if (fetchId !== latestFetchId) {
        return;
      }

      dispatch({
        type: casestudyListActions.FETCH_SUCCESS,
        payload: {
          rows: response.rows,
          count: response.count,
        },
      });
    } catch (error) {
      if (fetchId !== latestFetchId) {
        return;
      }

      Errors.handle(error);

      dispatch({
        type: casestudyListActions.FETCH_ERROR,
      });
    }
  },
};

export default casestudyListActions;
